export const ABOUT = {
  en: {
    label: "A Little About Us",
    headingA: "Welcome to",
    headingB: "Cabo Yoga & Fitness",
    lead: "Cabo Yoga & Fitness is more than a place to take a class. It is a community dedicated to movement, wellness, and connection.",
    paragraphs: [
      "Our mission is to make a positive difference in people’s lives by creating a welcoming and supportive space for all levels of yoga and fitness. Through yoga, meditation, therapeutic sound, fitness, and mindful movement, we encourage our community to build strength, find balance, reduce stress, and feel their best, both physically and mentally.",
      "We believe wellness is for everyone. Our studio is a safe, nurturing, and positive environment where people can come together, support one another, and work toward a healthier, more balanced lifestyle.",
      "Whether you are stepping onto the mat for the first time or have been practicing for years, you are always welcome here.",
    ],
    closing: "Move. Breathe. Connect. Feel better.",
  },
  es: {
    label: "Un Poco Sobre Nosotros",
    headingA: "Bienvenidos a",
    headingB: "Cabo Yoga & Fitness",
    lead: "Cabo Yoga & Fitness es mucho más que un lugar para tomar una clase: es una comunidad dedicada al movimiento, el bienestar y la conexión.",
    paragraphs: [
      "Nuestra misión es generar un impacto positivo en la vida de las personas al crear un espacio acogedor y de apoyo para todos los niveles de yoga y fitness. A través del yoga, la meditación, el sonido terapéutico, el fitness y el movimiento consciente, motivamos a nuestra comunidad a desarrollar fuerza, encontrar equilibrio, reducir el estrés y sentirse mejor, tanto física como mentalmente.",
      "Creemos que el bienestar es para todos. Nuestro estudio es un entorno seguro, positivo y lleno de apoyo, donde las personas pueden reunirse, acompañarse y trabajar para alcanzar un estilo de vida más saludable y equilibrado.",
      "Ya sea que te subas al mat por primera vez o que lleves años practicando, siempre serás bienvenido aquí.",
    ],
    closing: "Muévete. Respira. Conecta. Siéntete mejor.",
  },
};
